<template>
<section>
        <p class="mt-1 text-gray-500">{{display}}</p>
    <div v-for="list in mailingList" :key="list" class="mt-4">
        <ul style="list-style-type: square;">
            <li>{{list.email}}</li>
        </ul>
       
    </div>
</section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            mailingList: [],
            display: ""
        }
    },

    mounted() {
        this.getMailingList();
    },

    methods : {
        getMailingList() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/extras/subscribers`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.mailingList = response.data.data.results;
                if(this.mailingList.length <= 0) {
                    this.display = "No mailing list yet"
                }
            })
            .catch((err) => err); 
        }
    }
}
</script>